var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8114 10.0415H21.0059V10H12.0059V14H17.6574C16.8329 16.3285 14.6174 18 12.0059 18C8.69236 18 6.00586 15.3135 6.00586 12C6.00586 8.6865 8.69236 6 12.0059 6C13.5354 6 14.9269 6.577 15.9864 7.5195L18.8149 4.691C17.0289 3.0265 14.6399 2 12.0059 2C6.48336 2 2.00586 6.4775 2.00586 12C2.00586 17.5225 6.48336 22 12.0059 22C17.5284 22 22.0059 17.5225 22.0059 12C22.0059 11.3295 21.9369 10.675 21.8114 10.0415Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15869 7.3455L6.44419 9.755C7.33319 7.554 9.48619 6 12.0057 6C13.5352 6 14.9267 6.577 15.9862 7.5195L18.8147 4.691C17.0287 3.0265 14.6397 2 12.0057 2C8.16469 2 4.83369 4.1685 3.15869 7.3455Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.006 22.0003C14.589 22.0003 16.936 21.0118 18.7105 19.4043L15.6155 16.7853C14.578 17.5749 13.3098 18.0017 12.006 18.0003C9.40502 18.0003 7.19652 16.3418 6.36452 14.0273L3.10352 16.5398C4.75852 19.7783 8.11952 22.0003 12.006 22.0003Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8114 10.0415H21.0059V10H12.0059V14H17.6574C17.263 15.1082 16.5525 16.0766 15.6139 16.7855L15.6154 16.7845L18.7104 19.4035C18.4914 19.6025 22.0059 17 22.0059 12C22.0059 11.3295 21.9369 10.675 21.8114 10.0415Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon_google.8fa148d8c17f0492e7d9b71f780dd189.svg";
export { ForwardRef as ReactComponent };